import React, { useEffect } from 'react';

import Loading from '../../components/Loading';

const { REACT_APP_PLATFORM_OLD_APPLICATION_START: PLATFORM_OLD_APPLICATION_START } = process.env;

const redirectUrl = () => PLATFORM_OLD_APPLICATION_START;

const RestartInPlatformPage = () => {
  useEffect(() => {
    window.location.href = redirectUrl();
  });

  return (
    <section className="container container--space-y text-center">
      <Loading />
    </section>
  );
};

export default RestartInPlatformPage;
